import { render, staticRenderFns } from "./ComponentCompositionTab.vue?vue&type=template&id=80f3cd2e&scoped=true&"
import script from "./ComponentCompositionTab.vue?vue&type=script&lang=js&"
export * from "./ComponentCompositionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f3cd2e",
  null
  
)

export default component.exports